import produce from 'immer'
import Actions from '../actions'
import { ACTIVITY_CATEGORIES } from '../consts/activityCategories'

const initialState = {
  notifications: [],
  prevNotifications: [], // used to compare with new notifications to determine if there are new notifications (for requesting patient docs in case needed)
  unreadNotificationCount: 0,
  selectedCategory: ACTIVITY_CATEGORIES.ALL,
  notificationsByCategory: [],
}

export default produce((draft, action) => {
  const { payload } = action

  switch (action.type) {
    case Actions.NOTIFICATIONS_REQUESTED: {
      draft.prevNotifications = draft.notifications
      break
    }
    case Actions.NOTIFICATIONS_RECEIVED: {
      draft.notifications = payload?.notifications
      draft.notificationsByCategory = payload?.notifications?.filter(
        item =>
          draft.selectedCategory === ACTIVITY_CATEGORIES.ALL ||
          item?.category === draft.selectedCategory
      )
      draft.unreadNotificationCount = payload?.notifications?.filter(
        item => !item.isRead
      )?.length
      break
    }
    case Actions.NOTIFICATIONS_CATEGORY_CHANGED: {
      draft.selectedCategory = payload
      draft.notificationsByCategory = draft.notifications?.filter(
        item =>
          payload === ACTIVITY_CATEGORIES.ALL || item?.category === payload
      )
      break
    }
    case Actions.SIGNOUT_RECEIVED: {
      return initialState
    }
    default: {
      // Nothing to do
      break
    }
  }
}, initialState)
